import { LegalLayout, headingStyle, paragraphStyle, sectionStyle, listStyle, SupportEmail } from "./LegalLayout";

export function PrivacyPolicyPage() {
  return (
    <LegalLayout title="Политика конфиденциальности">
      <section style={sectionStyle}>
        <h2 style={headingStyle}>Какие данные обрабатываются</h2>
        <p style={paragraphStyle}>Hockey Planner обрабатывает данные, необходимые для работы сервиса:</p>
        <ul style={listStyle}>
          <li>данные аккаунта: email, пароль в защищённом виде, данные подтверждения почты;</li>
          <li>персональные данные пользователей: имя, фамилия, телефон, дата рождения при указании пользователем;</li>
          <li>информацию об игроках: номер, позиция, хват, рост, вес, привязка к внешнему профилю при наличии;</li>
          <li>информацию о командах, участниках, ролях, приглашениях, новостях и мероприятиях;</li>
          <li>фотографии и изображения, загруженные пользователями или администраторами команд;</li>
          <li>журналы действий, обращения пользователей, статусы уведомлений и технические записи;</li>
          <li>cookies, local storage, push-подписки, сведения об устройстве, браузере, IP-адресе и технических ошибках.</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Цели обработки</h2>
        <p style={paragraphStyle}>
          Данные используются для регистрации и входа, управления командами, расписанием, явкой, составами, новостями, уведомлениями,
          поддержки пользователей, обеспечения безопасности, диагностики ошибок и развития сервиса.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Хранение и защита</h2>
        <p style={paragraphStyle}>
          Данные хранятся в инфраструктуре, используемой для работы Hockey Planner, и защищаются организационными и техническими мерами.
          Доступ к административным функциям ограничивается ролями. Пользователь может настраивать видимость отдельных данных профиля в настройках приватности.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Передача третьим лицам</h2>
        <p style={paragraphStyle}>
          Данные могут передаваться сервисам хостинга, хранения изображений, отправки email, push-уведомлений и иным техническим подрядчикам
          только в объёме, необходимом для работы Hockey Planner, исполнения обязательств и соблюдения требований закона.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Права пользователя</h2>
        <p style={paragraphStyle}>
          Пользователь может обратиться по вопросам доступа, исправления или удаления данных, написав на <SupportEmail />.
          В отдельных случаях часть данных может сохраняться в течение периода, необходимого для обеспечения безопасности, соблюдения требований закона или защиты прав.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Изменение политики</h2>
        <p style={paragraphStyle}>
          Политика конфиденциальности может обновляться. Актуальная версия публикуется на этой странице.
        </p>
      </section>
    </LegalLayout>
  );
}
